<template>
    <ui-dropdown placement="bottom-start" menu-class="w-full max-w-lg">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>

        <template #menu="{ close }">
            <div class="p-3 max-h-64 overflow-y-auto">
                <!-- Empty State. -->
                <div
                    v-if="!contacts.packageData && !query"
                    class="text-gray-500 text-sm"
                >
                    Start typing to search for known contact...
                </div>

                <div v-else class="space-y-6">
                    <div v-if="packageFilteredContacts.length > 0">
                        <div
                            class="ml-2 text-xs font-medium text-gray-400 mb-1"
                            v-text="contacts.packageData.name"
                        ></div>
                        <div class="space-y-1">
                            <button
                                v-for="contact in packageFilteredContacts"
                                class="flex items-center space-x-2 text-left w-full rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                :title="contact.name"
                                @click="selectContact(contact, close)"
                            >
                                <div class="truncate flex-1 flex flex-col">
                                    <div
                                        class="truncate w-full"
                                        :class="mode === 'phone' ? 'text-gray-400' : ''"
                                    >
                                        {{ contact.name }}
                                    </div>
                                    <div class="truncate w-full" v-if="showPhone">
                                        {{ contact.phone }}
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div v-if="query && filteredContacts.length > 0">
                        <div
                            class="ml-2 text-xs font-medium text-gray-400 mb-1"
                            v-text="
                (contacts.packageData ? 'Other ' : '') + 'Package Contacts'
              "
                        ></div>
                        <div class="space-y-1">
                            <button
                                v-for="contact in filteredContacts"
                                class="flex items-center space-x-2 text-left w-full rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                :title="contact.name"
                                @click="selectContact(contact, close)"
                            >
                                <div class="truncate flex-1 flex flex-col">
                                    <div
                                        class="truncate w-full"
                                        :class="mode === 'phone' ? 'text-gray-400' : ''"
                                    >
                                        {{ contact.name }}
                                    </div>
                                    <div class="truncate w-full" v-if="showPhone">
                                        {{ contact.phone }}
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div
                        v-if="
              query &&
              filteredContacts.length === 0 &&
              packageFilteredContacts.length === 0
            "
                        class="text-gray-500 text-sm"
                    >
                        No matching contacts found.
                    </div>
                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>
export default {
    props: {
        top: Boolean,
        buttonClass: {
            type: String,
            default:
                "text-left w-full rounded-md px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-600",
        },
        contacts: Object,
        mode: {
            type: String,
            default: "",
        },
        showPhone: false,
    },
    data() {
        return {
            query: "",
        };
    },
    watch: {
        contactData: function (newValue, oldValue) {
            this.$forceUpdate();
        },
    },
    computed: {
        filteredContacts() {
            return this.contacts.data
                .filter(this.matchContact)
                .filter(
                    (i) => !this.packageFilteredContacts.some((d) => d.name === i.name)
                )
                .sort((a, b) => {
                    let score = 0;
                    score += a.phone ? 0 : 1;
                    score += b.phone ? 0 : -1;
                    return score;
                })
                .slice(0, 100);
        },
        packageFilteredContacts() {
            if (
                !this.contacts.loaded ||
                !this.contacts.packageData ||
                !this.contacts.contacts
            ) {
                return [];
            }
            return this.contacts.packageData.contacts
                .filter(this.matchContact)
                .sort((a, b) => {
                    let score = 0;
                    score += a.phone ? 0 : 1;
                    score += b.phone ? 0 : -1;
                    return score;
                })
                .slice(0, 100);
        },
        contactData() {
            return this.contacts.loaded;
        },
    },
    methods: {
        scope(dropdownScope) {
            return {
                query: this.query,
                setQuery: this.setQuery,
                ...dropdownScope,
            };
        },
        setQuery(query) {
            this.query = query;
            if (!this.query) return;
        },
        matchContact(contact) {
            const query = this.query.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            let ret = query.every((token) => {
                return (contact.name + "|" + contact.phone + "|" + contact.phone2)
                    .toLowerCase()
                    .includes(token);
            });
            return ret;
        },
        selectContact(contact, close) {
            this.$emit("selected:contact", contact);
            this.query = contact.name;
            close();
        },
    },
};
</script>
